import { useState } from "react";
import { MdInfo } from "react-icons/md";
import style from "./ToolTip.module.scss";
interface ToolTipProps {
  text: string;
}

const ToolTip = ({ text }: ToolTipProps) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  return (
    <div
      style={{ position: "relative", display: "inline-block", lineHeight: 0 }}
    >
      <span
        tabIndex={0}
        onMouseEnter={() => setIsTooltipVisible(true)}
        onMouseLeave={() => setIsTooltipVisible(false)}
        onFocus={() => setIsTooltipVisible(true)}
        onBlur={() => setIsTooltipVisible(false)}
        onClick={() => setIsTooltipVisible((prev) => !prev)}
        style={{ cursor: "pointer" }}
      >
        <MdInfo size={24} />
      </span>
      {isTooltipVisible && <p className={style.ToolTip}>{text}</p>}
    </div>
  );
};

export default ToolTip;
